<template>
   <div class="mylogin-navbar row">
      <div class="col  s12 yo-align-right">
         <el-menu default-active="1"  mode="horizontal" :router="true" @select="handleSelect">

            <el-submenu index="a" class="">
               <template slot="title"><div class="yo-text-n">{{$teras.utente.nome}} {{$teras.utente.cognome}}</div></template>
               <el-menu-item index="/mylogin-res">Corsi residenziali</el-menu-item>
               <el-menu-item index="/mylogin-fad">Corsi FAD</el-menu-item>
               <!-- tolta a settembre 2021 in attesa di integrazione con ital <el-menu-item index="/mylogin-crediti">Crediti ECM</el-menu-item> -->
               <el-menu-item index="/contatto-edit">Modifica profilo</el-menu-item>
               <el-menu-item index="/contatto-password">Modifica password</el-menu-item>
               <el-menu-item index="/contatto-privacy">Modifica privacy</el-menu-item>
               <el-menu-item index="/mylogin-home">Mylogin</el-menu-item>
               <el-menu-item index="logout">Esci - Logout</el-menu-item>
            </el-submenu>

            <!-- 
            <el-menu-item index="/loadpage/comitati/comitati" class="">Comitati</el-menu-item>
            -->

         </el-menu>
      </div>
   </div>
</template>

<script>
export default {
  name: 'site-navbar',
  created () {
    console.log("Created Site-logged.vue")
    console.log(this.axios.mysql)
    this.axios.sessionGet('session_id').then((data) => {
      console.log("))))))))))))))))))))))))))))))))")
      console.log(data.key)
    })
  },
  methods: {
    handleSelect(key, keyPath) {
       console.log(key)
        if(key=='logout'){
         this.$teras.event.emit('logout')
            
        }
        else if(keyPath=='/page/f/4'){
           
        }
        else {
            
        }

        
        

    }
  }
}
</script>

<style>

/* SITE-NAVBAR */
.mylogin-navbar{
  background:transparent !important;
}.mylogin-navbar .el-menu--horizontal>.el-submenu{

   float:right;

}.el-menu--horizontal>.el-submenu .el-submenu__title{
   color:#fff !important;
  height:24px !important;   
  line-height:24px !important;
}.mylogin-navbar .el-menu--horizontal > .el-submenu__title:hover{
   background: transparent !important;
}.mylogin-navbar ul.el-menu{
  background: transparent !important;
  margin:0 auto !important;

}.site-navbar li, .site-navbar .el-submenu .el-submenu__title, .site-navbar .el-submenu.is-active .el-submenu__title, .site-navbar .el-submenu .el-submenu__icon-arrow{
  color:#ffffff !important;
  font-size:1.4rem;
  letter-spacing: -.6px;
  padding:0;
  text-align:center;
  line-height:24px !important;
  height:24px !important;
  border:none !important;
}.site-navbar .el-menu > .el-menu-item, .site-navbar .el-menu > .el-submenu{
  width: 14.28% !important;
  color:#ffffff !important;
  font-size:1.4rem;
  border-bottom:none !important;
  line-height:24px;
  height:24px;
}li.el-menu-item:last-child{
  margin:0;    
}.site-navbar .el-menu-item:hover,.site-navbar .el-menu-item:focus, .site-navbar .el-submenu:hover , .site-navbar .el-submenu:hover .el-submenu__title:hover{
  color:#ffffff !important;
  border-bottom:darkred;
  background-color: #00ADEF !important;
}.site-navbar .el-submenu > .el-menu{
  width:100px !important;
}.site-navbar .el-submenu > .el-menu .el-menu-item{
  color:#ffffff;
  background-color: #00ADEF !important;
  padding:0 10px;
  text-align:left;
  width: 100px !important;
  overflow:hidden;
  margin:0;
}.el-menu-item a{
  display:block;
}.el-menu--horizontal .el-submenu .el-submenu__icon-arrow{
  color:#ffffff !important;
}.el-menu--horizontal>.el-menu-item:hover, .el-menu--horizontal>.el-submenu.is-active .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
   color:#fff;
  border-bottom:none !important;
  background-color: transparent !important;
}.el-menu--horizontal .el-submenu>.el-menu{
  top:24px !important;
  padding:0 !important;
  border:none !important;
  border-radius: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Mylogin-navbar.vue